/**
 * mcp-api.ts — AI-innstillingene i chatten mot den ekte backend
 *
 * MCP-servere: POST /api/ai/mcp/servers
 */

import { createMcpServer, deleteMcpServer, fetchMcpServers, updateMcpServer } from '@/lib/api';
import type { AiSettingsApi } from '@/types/ai';

export const realAiSettings: AiSettingsApi = {
  mcp: {
    list: fetchMcpServers,
    create: createMcpServer,
    update: updateMcpServer,
    remove: deleteMcpServer,
  },
};
